const STANDARD = "STANDARD";
const SHOPIFY_APPSTORE = "SHOPIFY_APPSTORE";
const LEX_OFFICE = "LEX_OFFICE";
const TAX_AGENCY = "TAX_AGENCY";
export const OrganizationType = {
    STANDARD,
    SHOPIFY_APPSTORE,
    LEX_OFFICE,
    TAX_AGENCY,
};
